import {
  MinusCircleOutlined,
  PlusOutlined,
  UploadOutlined
} from '@ant-design/icons'
import {
  Button,
  Empty,
  Form,
  Input,
  InputNumber,
  Modal,
  Switch,
  Upload
} from 'antd'
import { useWatch } from 'antd/es/form/Form'
import React, { useRef, useState } from 'react'
import { formatCurrencyLabel, removeVietnameseTones } from '../../config-func'
import InputField from '../common/Input/InputField'
import openNotification from '../common/Notification/openNotification '
import SelectField from '../common/Select/SelectField'
import styles from './styles.module.scss'

const FormPost = ({
  form,
  handleSearch,
  listDepartment,
  LabelType,
  ProductType,
  typeRealEstate,
  listProject,
  cities,
  districts,
  towns,
  postType,
  fileList,
  handleCustomRequest,
  handleChange,
  handlePreview,
  previewVisible,
  previewTitle,
  handleCancel,
  onChangeProject,
  previewImage,
  onChangePostType,
  onChangeCity,
  onChangeDistrict,
  fileListVideo,
  fileList360,
  onChangeDepartment,
  totalSize,
  setFileList360,
  isText,
  setIsText,
  demandOps,
  typeOfRealEstateOps,
  apartmentLocationOptions,
  directionOptions,
  furnitureOptions,
  currentStatusOpstions,
  postStatusOptions,
  postSecurityOptions,
  legalOptions,
  procedureOptions
}) => {
  const labelCheck = useWatch('label', form)
  const [costLabel, setCostLabel] = useState('')
  const [priceLabel, setPriceLabel] = useState('')

  // Add function to update title based on selected fields
  const updateTitle = () => {
    const label = form.getFieldValue('label')
    const typeRealEstateValue = form.getFieldValue('type_real_estate')
    const projectId = form.getFieldValue('project_id')

    if (label && typeRealEstateValue) {
      let title = ''

      // Get label text
      const labelOption = demandOps?.find((option) => option.value === label)

      const labelText = labelOption ? labelOption.label : ''

      // Get type real estate text
      let typeRealEstateText = ''
      if (Array.isArray(typeRealEstate)) {
        const typeRealEstateOption = typeRealEstate.find(
          (option) => option.value === typeRealEstateValue
        )
        typeRealEstateText = typeRealEstateOption
          ? typeRealEstateOption.label
          : ''
      } else if (
        typeof typeRealEstate === 'object' &&
        typeRealEstate !== null
      ) {
        // If typeRealEstate is an object with options property
        const typeRealEstateOption = typeRealEstate.options?.find(
          (option) => option.value === typeRealEstateValue
        )
        typeRealEstateText = typeRealEstateOption
          ? typeRealEstateOption.label
          : ''
      }

      // Get project name if available
      let projectName = ''
      if (projectId) {
        const projectOption = listProject?.find(
          (option) => option.value === projectId
        )
        projectName = projectOption ? projectOption.label : ''
      }

      // Construct title
      title = `${labelText} ${typeRealEstateText}`
      if (projectName) {
        title += ` ${projectName}`
      }

      // Set the title field
      form.setFieldsValue({ title })
    }
  }

  // Custom onChange handler for label field
  const handleLabelChange = (value) => {
    form.setFieldsValue({ label: value })
    updateTitle()
  }

  // Custom onChange handler for type_real_estate field
  const handleTypeRealEstateChange = (value) => {
    form.setFieldsValue({ type_real_estate: value })
    updateTitle()
  }

  // Custom onChange handler for project_id field
  const handleProjectChange = (value) => {
    onChangeProject(value)
    updateTitle()
  }

  const UploadButton = () => {
    return (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    )
  }

  const beforeUploadImage = (file) => {
    const isAllowedType = ['image/jpeg', 'image/png', 'image/gif'].includes(
      file.type
    )
    if (!isAllowedType) {
      openNotification('error', 'Chỉ hỗ trợ định dạng JPG, PNG, GIF!')
      return Upload.LIST_IGNORE
    }

    const isLt100M = file.size / 1024 / 1024 < 100
    if (!isLt100M) {
      openNotification('error', 'Dung lượng file phải nhỏ hơn 100MB!')
      return Upload.LIST_IGNORE
    }
    return new Promise((resolve) => {
      const img = new Image()
      img.src = URL.createObjectURL(file)
      img.onload = () => {
        if (img.width >= 300 && img.height >= 300) {
          resolve(true)
        } else {
          openNotification(
            'error',
            'Kích thước ảnh tối thiểu phải là 300x300px!'
          )
          resolve(Upload.LIST_IGNORE)
        }
      }
    })
  }

  const beforeUpload = (file) => {
    const isVideo = file.type.startsWith('video/')
    const isLt100MB = file.size / 1024 / 1024 < 100 // Giới hạn 100MB

    if (!isVideo) {
      openNotification('error', 'Chỉ được phép tải lên video!')
      return Upload.LIST_IGNORE
    }

    if (!isLt100MB) {
      openNotification('error', 'Video không được vượt quá 100MB!')
      return Upload.LIST_IGNORE
    }

    return true
  }

  const handleProjectSelect = (project) => {
    form.setFieldsValue({
      project_id: project.value
    })
    onChangeProject(project.value)
  }

  const selectRef = useRef()

  const closeDropdown = () => {
    if (selectRef.current) {
      selectRef.current.blur() // This closes the dropdown
    }
  }

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSearch}
        // labelCol={{ span: 8 }}
        labelAlign="right"
        style={{
          marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        onValuesChange={(value, allValues) =>
          console.log('vaaaaaa', value, allValues)
        }
        // initialValues={{ image_360: [''] }}
      >
        <div className={styles.formAdd}>
          <Form.Item label="" name="id" style={{ display: 'none' }}>
            <Input />
          </Form.Item>

          <SelectField
            label="Sàn"
            name="department_id"
            required={true}
            options={listDepartment}
            onChange={onChangeDepartment}
          />

          <SelectField
            label="Nhu cầu đăng tin"
            name="label"
            required={true}
            options={demandOps}
            placeholder="Chọn nhu cầu đăng tin"
            onChange={handleLabelChange}
          />
          <SelectField
            label="Loại BĐS"
            name="post_type"
            required={true}
            options={typeOfRealEstateOps}
            onChange={onChangePostType}
          />
          <SelectField
            label="Loại hình BĐS"
            name="type_real_estate"
            required={true}
            options={typeRealEstate}
            onChange={handleTypeRealEstateChange}
          />

          {[1, 2].includes(labelCheck) && (
            <SelectField
              ref={selectRef}
              label={`Tên dự án ${
                postType === '2'
                  ? 'Tòa nhà (Nếu có)'
                  : postType === '4'
                  ? 'Đất nền (Nếu có)'
                  : postType === '3'
                  ? 'Nhà đất (Nếu có)'
                  : ''
              }`}
              name="project_id"
              rules={[
                {
                  required: postType === '1',
                  message: 'Vui lòng chọn dự án'
                }
              ]}
              onChange={handleProjectChange}
              // onChange={(e) => onChangeProject(e)}
              options={listProject}
              showSearch
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
              notFoundContent={
                postType === '1' ? (
                  <div style={{ padding: '0px' }}>
                    {listProject.find(
                      (project) => project.label.toLowerCase() === 'dự án khác'
                    ) && (
                      <div
                        className={styles.otherProjectOption}
                        onClick={() => {
                          const otherProject = listProject.find(
                            (project) =>
                              project.label.toLowerCase() === 'dự án khác'
                          )
                          if (otherProject) {
                            handleProjectSelect(otherProject)
                            closeDropdown() // Close the dropdown after selection
                          }
                        }}
                      >
                        Dự án khác
                      </div>
                    )}
                  </div>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No data"
                    style={{ padding: '0px' }}
                  />
                )
              }
            />
          )}

          <SelectField
            label="Tỉnh/Thành phố"
            name="city_code"
            required={true}
            onChange={onChangeCity}
            options={cities}
          />
          <SelectField
            label="Quận/Huyện"
            name="district_code"
            required={true}
            onChange={onChangeDistrict}
            options={districts}
          />
          <SelectField
            label={`Phường/xã`}
            name="town_code"
            required={true}
            options={towns}
          />

          <InputField label="Đường/phố" name="street" form={form} />

          {/* {postType === 1 && (
            <InputField label="Mã căn hộ" name="apartment_code" form={form} />
          )} */}
          {/* {postType === 1 && (
            <InputField label="Toà/Khu" name="building" form={form} />
          )} */}
          {/* {postType === 1 && (
            <InputField label="Tầng/Dãy" name="floor" form={form} />
          )} */}
          {/* {postType === 1 && (
            <InputField label="Số căn" name="number_of_rooms" form={form} />
          )} */}

          {/* {!(postType === 1) && (
            <InputField label="Sổ địa chỉ" name="alley" form={form} />
          )} */}

          {[3, 4].includes(labelCheck) && postType !== '1' && (
            // <InputField label="Diện tích (m2)" name="acreage" form={form} />
            <Form.Item
              label="Diện tích (m2)"
              name="acreage"
              className={styles.formItem}
            >
              <InputNumber
                onBlur={(e) => {
                  const value = parseFloat(e.target.value?.trim())
                  form.setFields([
                    {
                      name: 'acreage',
                      value: isNaN(value) ? 0 : value
                    }
                  ])
                }}
                className={styles.InputNumber}
                formatter={(value) =>
                  value ? value.replace(/[^0-9.]/g, '') : ''
                }
                parser={(value) => value.replace(/[^0-9.]/g, '.')}
                placeholder="Nhập diện tích"
              />
            </Form.Item>
          )}

          {![3, 4].includes(labelCheck) && (
            // <InputField label="Diện tích (m2)" name="acreage" form={form} />
            <Form.Item
              label="Diện tích (m2)"
              name="acreage"
              className={styles.formItem}
            >
              <InputNumber
                onBlur={(e) => {
                  const value = parseFloat(e.target.value?.trim())
                  form.setFields([
                    {
                      name: 'acreage',
                      value: isNaN(value) ? 0 : value
                    }
                  ])
                }}
                className={styles.InputNumber}
                formatter={(value) =>
                  value ? value.replace(/[^0-9.]/g, '') : ''
                }
                parser={(value) => value.replace(/[^0-9.]/g, '.')}
                placeholder="Nhập diện tích"
              />
            </Form.Item>
          )}

          {postType != '1' && (
            <Form.Item
              label="Mặt tiền (m)"
              name="area_outside"
              className={styles.formItem}
            >
              <InputNumber
                onBlur={(e) => {
                  const value = parseFloat(e.target.value?.trim())
                  form.setFields([
                    {
                      name: 'area_outside',
                      value: isNaN(value) ? 0 : value
                    }
                  ])
                }}
                className={styles.InputNumber}
                formatter={(value) =>
                  value ? value.replace(/[^0-9.]/g, '') : ''
                }
                parser={(value) => value.replace(/[^0-9.]/g, '.')}
                placeholder="Nhập kích thước"
              />
            </Form.Item>
          )}

          {(postType === '2' || postType === '3') && (
            <InputField label="Số tầng" name="number_of_floor" form={form} />
          )}

          {(postType === '1' ||
            (postType === '3' && ![3, 4].includes(labelCheck))) && (
            <InputField
              label="Số phòng ngủ"
              name="number_of_bedrooms"
              form={form}
            />
          )}

          {(postType === '1' || postType === '3') &&
            [1, 2].includes(labelCheck) && (
              <Form.Item
                label="Số WC"
                name="number_of_wc"
                className={styles.formItem}
              >
                <InputNumber
                  min={1}
                  onBlur={(e) => {
                    form.setFields([
                      {
                        name: 'number_of_wc',
                        value: e.target.value?.trim()
                      }
                    ])
                  }}
                  className={styles.InputNumber}
                  maxLength={10}
                  placeholder="Nhập số WC"
                />
              </Form.Item>
            )}

          <SelectField
            label="Vị trí"
            name="apartment_location"
            options={apartmentLocationOptions}
          />
          <SelectField
            label="Hướng"
            name="direction"
            options={directionOptions}
          />

          {[3, 4].includes(labelCheck) && (
            <Form.Item
              label={`Tài chính:  ${formatCurrencyLabel(
                String(form.getFieldValue('price'))?.replaceAll('.', '')
              )}`}
              name="price"
              className={styles.formItem}
            >
              <InputNumber
                placeholder="Nhập tài chính"
                onBlur={() => {
                  const rawValue = form.getFieldValue('price')
                  form.setFields([
                    {
                      name: 'price',
                      value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
                    }
                  ])
                }}
                onChange={(value) => {
                  setPriceLabel(formatCurrencyLabel(value))
                }}
                className={styles.InputNumber}
                formatter={(value) => {
                  if (!value) return ''
                  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }}
                parser={(value) => (value ? value.replace(/\./g, '') : '')}
                maxLength={255}
              />
            </Form.Item>
          )}
          {![3, 4].includes(labelCheck) && (
            <>
              <SelectField
                label="Giấy tờ pháp lý"
                name="legal"
                options={legalOptions}
              />
              {/* <Form.Item
                label={`Giá: ${priceLabel}`}
                name="price"
                className={styles.formItem}
              >
                <InputNumber
                  placeholder="Nhập giá"
                  onBlur={() => {
                    const rawValue = form.getFieldValue('price')
                    form.setFields([
                      {
                        name: 'price',
                        value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
                      }
                    ])
                  }}
                  onChange={(value) => {
                    setPriceLabel(formatCurrencyLabel(value))
                  }}
                  className={styles.InputNumber}
                  formatter={(value) => {
                    if (!value) return ''
                    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }}
                  parser={(value) => (value ? value.replace(/\./g, '') : '')}
                  maxLength={255}
                />
              </Form.Item>
              <Form.Item
                label={`Phí môi giới: ${costLabel}`}
                name="cost"
                className={styles.formItem}
              >
                <InputNumber
                  placeholder="Nhập phí môi giới"
                  onBlur={() => {
                    const rawValue = form.getFieldValue('cost')
                    form.setFields([
                      {
                        name: 'cost',
                        value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
                      }
                    ])
                  }}
                  onChange={(value) => {
                    setCostLabel(formatCurrencyLabel(value))
                  }}
                  className={styles.InputNumber}
                  formatter={(value) => {
                    if (!value) return ''
                    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }}
                  parser={(value) => (value ? value.replace(/\./g, '') : '')}
                  maxLength={255}
                />
              </Form.Item> */}
              <SelectField
                label="Phí giao dịch"
                name="procedure"
                options={procedureOptions}
              />
            </>
          )}

          {postType != '4' && ![3, 4].includes(labelCheck) && (
            <SelectField
              label="Nội thất"
              name="furniture"
              options={furnitureOptions}
            />
          )}

          {![3, 4].includes(labelCheck) && (
            <>
              <Form.Item
                label={`Giá: ${formatCurrencyLabel(
                  String(form.getFieldValue('price'))?.replaceAll('.', '')
                )}`}
                name="price"
                className={styles.formItem}
              >
                <InputNumber
                  placeholder="Nhập giá"
                  onBlur={() => {
                    const rawValue = form.getFieldValue('price')
                    form.setFields([
                      {
                        name: 'price',
                        value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
                      }
                    ])
                  }}
                  onChange={(value) => {
                    setPriceLabel(formatCurrencyLabel(value))
                  }}
                  className={styles.InputNumber}
                  formatter={(value) => {
                    if (!value) return ''
                    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }}
                  parser={(value) => (value ? value.replace(/\./g, '') : '')}
                  maxLength={255}
                />
              </Form.Item>
              <Form.Item
                label={`Phí môi giới: ${formatCurrencyLabel(
                  form.getFieldValue('cost')
                )}`}
                name="cost"
                className={styles.formItem}
              >
                <InputNumber
                  placeholder="Nhập phí môi giới"
                  onBlur={() => {
                    const rawValue = form.getFieldValue('cost')
                    form.setFields([
                      {
                        name: 'cost',
                        value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
                      }
                    ])
                  }}
                  onChange={(value) => {
                    setCostLabel(formatCurrencyLabel(value))
                  }}
                  className={styles.InputNumber}
                  formatter={(value) => {
                    if (!value) return ''
                    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }}
                  parser={(value) => (value ? value.replace(/\./g, '') : '')}
                  maxLength={255}
                />
              </Form.Item>
            </>
          )}

          <InputField label="Tiêu đề" name="title" form={form} />

          {/* <SelectField label="Hiện trạng" name="status" options={status} /> */}
          {/* <SelectField
            label="Trạng thái tin"
            name="processing_status"
            options={statusList}
            required={true}
          /> */}
          {/* <SelectField
            label="Bảo mật thông tin"
            name="security"
            options={SECURITY_TYPE}
            required={true}
          /> */}

          {/* <InputField label="Tên chủ nhà" name="customer_name" form={form} /> */}
          {/* <InputField
            label="Số điện thoại liên hệ"
            name="customer_phone_number"
            form={form}
            rules={[
              {
                pattern: /^0\d{9}$/,
                message:
                  'Số điện thoại không hợp lệ (cần bắt đầu bằng 0 và có 10 số)'
              }
            ]}
          /> */}
        </div>
        <Form.Item
          label="Mô tả"
          name="description"
          className={styles.formFull}
          // rules={[{ required: true, message: 'Vui lòng nhập thông tin' }]}
        >
          <Input.TextArea
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'description',
                  value: e.target.value?.trim()
                }
              ])
            }}
            placeholder="Nhập mô tả"
            maxLength={255}
          />
        </Form.Item>
        <Form.Item
          label="Hình ảnh"
          name="image_urls"
          className={styles.formItem}
        >
          <Upload
            accept="image/*" // Chỉ cho phép upload file video
            beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
            customRequest={(options) => handleCustomRequest(options, 'image')} // Sử dụng custom request để gọi API của bạn
            onChange={(e) => {
              handleChange(e, 'image')
            }}
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            multiple={true}
            maxCount={9}
          >
            {fileList.length < 9 && <UploadButton />}
          </Upload>
          <span style={{ fontWeight: 600, color: '#f54545', fontSize: 13 }}>
            *Note: Bạn chỉ chọn tối đa 9 file
          </span>

          <Modal
            visible={previewVisible}
            title={previewTitle}
            footer={null}
            onCancel={handleCancel}
          >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
          </Modal>
        </Form.Item>

        <Form.Item label="Video" name="video_urls" className={styles.formFull}>
          <Upload
            accept="video/*" // Chỉ cho phép upload file video
            beforeUpload={beforeUpload} // Kiểm tra trước khi upload
            customRequest={(options) => handleCustomRequest(options, 'video')} // Sử dụng custom request để gọi API của bạn
            onChange={(e) => {
              handleChange(e, 'video')
            }}
            //   listType="picture-card"
            // multiple={false}
            showUploadList={{ showPreviewIcon: false, showRemoveIcon: true }} // Hiển thị danh sách file
            fileList={fileListVideo}
            // onPreview={handlePreview}
            // onChange={handleChange}
          >
            <Button
              disabled={
                totalSize >= 100
                  ? true
                  : fileListVideo.length >= 3
                  ? true
                  : false
              }
              icon={<UploadOutlined />}
            >
              Chọn Video
            </Button>
          </Upload>
        </Form.Item>

        {isText ? (
          <Form.Item
            style={{ width: '100%' }}
            label={
              <>
                Hình ảnh 360
                <Switch
                  checkedChildren="Link"
                  unCheckedChildren="360"
                  checked={isText}
                  onChange={() => {
                    setIsText(!isText)
                    setFileList360([])
                  }}
                  style={{ marginLeft: 10 }}
                />
              </>
            }
            className={styles.formFull}
          >
            <Form.List name="image_360">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div
                      key={key}
                      style={{ display: 'flex', gap: 8, width: '100%' }}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'url']}
                        style={{ flex: 1, marginBottom: 12 }} // Đảm bảo Input chiếm toàn bộ không gian
                      >
                        <Input
                          placeholder="Nhập link..."
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                      <MinusCircleOutlined
                        onClick={() => remove(name)}
                        style={{ color: 'red' }}
                      />
                    </div>
                  ))}

                  {fields.length < 3 && (
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      // style={{ width: '100%' }}
                    >
                      Thêm link
                    </Button>
                  )}
                </>
              )}
            </Form.List>
          </Form.Item>
        ) : (
          <Form.Item
            label={
              <>
                Hình ảnh 360
                <Switch
                  checkedChildren="Link"
                  unCheckedChildren="360"
                  checked={isText}
                  onChange={() => {
                    setIsText(!isText)
                    form.setFieldsValue({ image_360: [''] })
                    setFileList360([])
                    // form.setFieldsValue({ image_360: [] })
                  }}
                  style={{ marginLeft: 10 }}
                />
              </>
            }
            name="image_360"
            className={styles.formFull}
          >
            <Upload
              accept="image/*" // Chỉ cho phép upload file video
              beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
              customRequest={(options) => handleCustomRequest(options, '360')} // Sử dụng custom request để gọi API của bạn
              onChange={(e) => {
                handleChange(e, '360')
              }}
              //   listType="picture-card"
              multiple={false}
              showUploadList={{
                showPreviewIcon: false,
                showRemoveIcon: true
              }} // Hiển thị danh sách file
              fileList={fileList360}
              // onPreview={handlePreview}
              // onChange={handleChange}
            >
              <Button
                disabled={
                  totalSize >= 100
                    ? true
                    : fileList360.length >= 3
                    ? true
                    : false
                }
                icon={<UploadOutlined />}
              >
                Chọn File 360
              </Button>
            </Upload>
          </Form.Item>
        )}
      </Form>
      {/* {mode !== 'ADD' && <Note postId={form.getFieldValue('id')} />} */}
    </>
  )
}

export default FormPost
